import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import BG1 from "../../carousel/slides/connection/files/bg1.js";
import BG2 from "../../carousel/slides/connection/files/bg2.js";
import BG3 from "../../carousel/slides/connection/files/bg3.js";
import styles from "./connection.module.css";

class Connection extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <div
          style={{ flex: "1", display: "inline-block", textAlign: "center" }}
        >
          <div
            style={{ fontWeight: "600", fontSize: "1.35vw", paddingTop: "3%" }}
          >
            Если вы хотите воспользоваться услугами ИС Теплоинформ, оставьте заявку на сайте
          </div>
        </div>
        <div style={{ flex: "3", display: "inline-block", width: "100%" }}>
          <div
            style={{
              display: "flex",
              textAlign: "center",
              alignItems: "center",
              paddingTop: "6.3%"
            }}
          >
            <div style={{ flex: "1" }}>
              <Link to="/zayv_na_uslugi">
                <div className={styles.iconTextContainer}>
                  <div
                    className={styles.iconContainer}
                    style={{
                      backgroundImage: <BG1 />,
                      backgroundColor: "transparent"
                    }}
                  >
                    <div className={styles.BGImg}>
                      <BG1 />
                    </div>
                  </div>
                  <div style={{ marginTop: "4%", textAlign: "left" }}>
                    <span style={{ paddingLeft: "30%", fontWeight: "600" }}>
                      Заключить договор на
                    </span>
                  </div>
                  <div style={{ textAlign: "left" }}>
                    <span style={{ paddingLeft: "31.6%", fontWeight: "600" }}>
                      услуги сбора данных
                    </span>
                  </div>
                </div>
              </Link>
            </div>
            <div style={{ flex: "1" }}>
              <Link to="/zayv_na_obor">
                <div className={styles.iconTextContainer}>
                  <div
                    className={styles.iconContainer}
                    style={{
                      backgroundImage: <BG2 />,
                      backgroundColor: "transparent"
                    }}
                  >
                    <div className={styles.BGImg}>
                      <BG2 />
                    </div>
                  </div>
                  <div style={{ marginTop: "4%", textAlign: "left" }}>
                    <span style={{ paddingLeft: "33%", fontWeight: "600" }}>
                      Заявка на установку
                    </span>
                  </div>
                  <div style={{ textAlign: "left" }}>
                    <span style={{ paddingLeft: "37.7%", fontWeight: "600" }}>
                      оборудования
                    </span>
                  </div>
                </div>
              </Link>
            </div>
            <div style={{ flex: "1" }}>
              <Link to="/zayv_na_vstr">
                <div className={styles.iconTextContainer}>
                  <div
                    className={styles.iconContainer}
                    style={{
                      backgroundImage: <BG3 />,
                      backgroundColor: "transparent"
                    }}
                  >
                    <div className={styles.BGImg}>
                      <BG3 />
                    </div>
                  </div>
                  <div style={{ marginTop: "4%", textAlign: "left" }}>
                    <span style={{ paddingLeft: "41.5%", fontWeight: "600" }}>
                      Заявка на
                    </span>
                  </div>
                  <div style={{ textAlign: "left" }}>
                    <span style={{ paddingLeft: "38.3%", fontWeight: "600" }}>
                      подключение
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div
          style={{ flex: "1", display: "inline-block", textAlign: "center" }}
        />
      </div>
    );
  }
}
export default Connection;
